
<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>

        <span class="my-auto f16 fw-bold me-2"> 

            {{ 
                
               bTotalFunctions ? 'سرجمع کارکرد رانندگان ' :
            
               bPresenceAbsence ? 'حضور غیاب رانندگان' :
               
               'کارکرد رانندگان به تفکیک تاریخ'
            
            }}
        
        </span>

    </div>

</div>

<form class="rtl  w-100 row gx-2 gy-4 gy-md-2 mt-2 p-2" [formGroup]="searchModel">

    <div class="col-12 col-md-2 position-relative">

        <label> از تاریخ </label>

        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

            [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

            <input type="text" formControlName="strSDate" placeholder="از تاریخ" class="form-control text-end" />

        </ng-persian-datepicker>

    </div>

    <div class="col-12 col-md-2 position-relative">

        <label> تا تاریخ </label>

        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

            [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

            <input type="text" formControlName="strEDate" placeholder="تا تاریخ" class="form-control text-end" />

        </ng-persian-datepicker>

    </div>

    <div *ngIf="list_Drivers.length > 0" class="col-12 col-md-3 position-relative">

        <label> نام راننده </label>

        <custom-filter *ngIf="list_Drivers.length > 0"

            [strValue]="returnStrValue('strFullName',searchModel.get('strFullName')?.value,list_Drivers,'strFullName')"

            [strComment]="'strFullName'"

            [stylesArray]="['padding-top: 10px']"

            [str_Placeholder]="'نام راننده را جستجو کنید'"

            [lst_Main]="list_Drivers" 

            [lst_SearchKey]="['strFullName']"

            [isDisabled]="false"
            
            (hideOptions)="selectedDriver($event)">

        </custom-filter>

    </div>

    <div class="col-12 col-md-2 ">

        <button class="btn px-5 btn-primary" style="max-height: 50px;" (click)="searchDriver_Function()"> گزارش </button>

    </div>

</form>

<main class="rtl p-2">

    <span class="mx-2" *ngIf="list_Function.length > 0"> تعداد 
        
        <span class="text-danger fw-bold"> {{list_Function.length | faNum}}</span>
        
        مورد یافت شد 
    
    </span>

    <div class="mt-3 border border-2 ">

        <div class="row gx-2 gy-2">

            <div [ngClass]="list_Function.length > 0 ? 'col-md-10' : 'col-12' " class="p-3" >

                <input type="search" #search (input)="searchBy(search.value)" 
                
                    class="form-control" placeholder="جستجو کنید ....">
    
            </div>
    
            <div *ngIf="list_Function.length > 0" class="col-12 col-md-2 p-3 text-end">
    
                <button class="btn btn-success" (click)="exportExcel()">
    
                    <span> خروجی اکسل </span>
    
                    <i class="fa fa-file-excel-o mx-2" aria-hidden="true"></i>
    
                </button>
                
            </div>

        </div>

        <div class="table-responsive" style="max-height: 74vh;">

            <table class="table table-striped" id="Export_Excel">

                <thead class="position-sticky top-0 bg-white">

                    <tr class="col-12 text-center">

                        <th> نام راننده </th>

                        <th> پرسنلی </th>

                        <th> پلاک </th>

                        <th> نوع خودرو </th>

                        <th> حوزه خدمت </th>

                        <!-- کارکرد رانندگان به تفکیک تاریخ -->

                        <ng-container *ngIf="!bTotalFunctions">

                            <th> تاریخ  </th>

                            <th> روز  </th>
    
                            <th> ساعت ورود  </th>
    
                            <th> ساعت خروج  </th>

                        </ng-container>

                        <th> مدت حضور  </th>

                        <!-- اگر صفحه حضور غیاب رانندگان نبود  -->

                        <ng-container *ngIf="!bPresenceAbsence">
                        
                            <th> مدت حرکت   </th>
    
                            <th> مدت توقف   </th>
    
                            <th> تعداد سفر   </th>
    
                            <th> پیمایش  </th>
    
                            <th> پیمایش ماموریتی </th>
    
                            <!-- کارکرد رانندگان به تفکیک تاریخ -->
    
                            <ng-container *ngIf="!bTotalFunctions">
    
                                <th> تعطیلات </th>
    
                            </ng-container>

                        </ng-container>

                    </tr>

                </thead>

                <tbody>

                    <ng-container *ngFor="let item of list_Function;let i = index;">

                        <tr class="col-12 text-center">

                            <td>{{ item.strFullName | faNum }}</td>

                            <td>{{ item.strPersonnelID | faNum }}</td>

                            <td>{{ item.strVehicleNo | faNum }}</td>
    
                            <td>{{ item.strMobileType_strComment }}</td>
    
                            <td>{{ item.strMobileDomain_strComment }}</td>

                            <!-- کارکرد رانندگان به تفکیک تاریخ -->

                            <ng-container *ngIf="!bTotalFunctions">

                                <td>{{ item.strDate | faNum }}</td>

                                <td>{{ item.strDayName }}</td>

                                <td>{{ item.strStartTime | faNum }}</td>

                                <td>{{ item.strEndTime | faNum }}</td>

                            </ng-container>

                            <td>{{ bPresenceAbsence ? (item.strTotalTime | faNum) :  (item.strPresentTime | faNum) }}</td>

                            <!-- اگر صفحه حضور غیاب رانندگان نبود  -->

                            <ng-container *ngIf="!bPresenceAbsence">

                                <td>{{ item.strMoveTime  | faNum }}</td>

                                <td>{{ item.strStopTime  | faNum }}</td>

                                <td>{{ item.tiTripCount | faNum }}</td>

                                <td>{{ item.fKm + ' کیلومتر '  | faNum }}</td>

                                <td>{{ item.fKmMission + ' کیلومتر '  | faNum }}</td>

                                <!-- کارکرد رانندگان به تفکیک تاریخ -->

                                <ng-container *ngIf="!bTotalFunctions">

                                    <td>{{ item.strComment == null ? '- - -' : item.strComment }}</td>

                                </ng-container>

                            </ng-container>

                        </tr>

                    </ng-container>

                    <!-- سرجمع -->

                    <ng-container *ngIf="list_Function.length > 0 && !bPresenceAbsence">

                        <tr class="col-12" style="background-color: #c7d2fe;">

                            <!-- مدت حضور -->
                        
                            <td class="col-4" colspan="2"> 
                                
                                <strong> مدت حضور : </strong>
                                
                                <span style="color: navy;">

                                    {{ format_Time(trip_Obj?.siPresentTime) | faNum }} 

                                </span> 
                            
                            </td>

                            <!-- مدت حرکت -->
                            
                            <td class="col-4" colspan="2"> 
                                
                                <strong> مدت حرکت : </strong>

                                <span style="color: navy;">

                                    {{ format_Time(trip_Obj?.siMoveTime) | faNum }} 

                                </span>
                            
                            </td>

                            <!-- مدت توقف -->

                            <td class="col-4" colspan="2"> 
                                
                                <strong> مدت توقف :</strong>

                                <span style="color: navy;">

                                    {{ format_Time(trip_Obj?.siStopTime) | faNum }} 

                                </span>
                            
                            </td>

                            <td class="col-4" colspan="2"> 
                                
                                <strong> تعداد سفر : </strong>

                                <span style="color: navy;">

                                    {{ trip_Obj?.tiTripCount | faNum }}  

                                </span>
                            
                            </td>

                            <td class="col-4" colspan="2"> 
                                
                                <strong> پیمایش : </strong>

                                <span style="color: navy;">

                                    {{ trip_Obj?.fKm.toFixed(2) | faNum }}  

                                </span>

                            
                            </td>

                            <td class="col-4" colspan="2"> 
                                
                                <strong> پیمایش ماموریتی : </strong>

                                <span style="color: navy;">

                                    {{ trip_Obj?.fKmMission.toFixed(2) | faNum }}  

                                </span>

                            
                            </td>

                            <!-- کارکرد رانندگان به تفکیک تاریخ -->

                            <ng-container *ngIf="!bTotalFunctions">

                                <td class="col-4" colspan="4"></td>

                            </ng-container>

                        </tr>

                    </ng-container>

                </tbody>

            </table>

        </div>

    </div>

</main>